import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
let service = new services();


export default {
    name: 'Dashboard',
    data () {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            businesses: {},
            business: {},
            contracts: {},
            contract: {},
            cnsurveys: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {}
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                    }else {
                       this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        resetPassword() {
            var credentials = {
                email: this.user.email,
                password: this.user.password,
            }

            if(credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.password == null || credentials.password == undefined || credentials.password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
                service.resetPassword(this, credentials).then((response) => {
                    if(response.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            localStorage.setItem("cityneeds_user", element.fullname);
                            //store session key here linked to session well @server

                            //display message here and redirect
                        }, this);
                        this.$router.push('dashboard');
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                    }
                })
            }
        },

        resetEmail() {
            var credentials = {
                email: this.user.email,
                password: this.user.password,
            }

            if(credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.password == null || credentials.password == undefined || credentials.password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
                service.resetEmail(this, credentials).then((response) => {
                    if(response.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            localStorage.setItem("cityneeds_user", element.fullname);
                            //store session key here linked to session well @server

                            //display message here and redirect
                        }, this);
                        this.$router.push('dashboard');
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                    }
                })
            }
        },

        editProfile() {
            var credentials = {
                user_fullname: this.user.name,
                user_phone: this.user.phone,
                user_address: this.user.address,
                user_state: this.user.state,
                user_city: this.user.city
            }

            let navi = this.$router;
            if(credentials.user_fullname != null || credentials.user_phone != null || credentials.user_city != null) {
                service.editProfile(this, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Profile Updated!", "Success!");
                        location.reload(true); //vm.$forceUpdate(); -- let vm = new Vue @main.js #check
                    }else {
                        toastr.error('Sorry, could not update Profile', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },

        //--//settings

        //businesses
        getBusinesses() {

            let user_id = this.user.user_id;
            
            service.getBusinesses(this, user_id).then(data => {
                if(data.body.status == 200) {
                    this.businesses = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        addBusiness() {
           var credentials = {
                business_user: this.user.user_id,
                business_category: this.business.category,
                business_name: this.business.name,
                business_email: this.business.email,
                business_phone: this.business.phone,
                business_address: this.business.address,
                business_state: this.business.state,
                business_city: this.business.city,
                business_description: this.business.description
            }

            let navi = this.$router;
            if(credentials.business_user != null || credentials.business_name != null || credentials.business_category != null) {
                service.addBusiness(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Business Added!", "Success!");
                        location.reload(true);
                    }else {
                        toastr.error('Sorry, could not add Business', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        //--//businesses

        //cnpros
        getCnpros() {

            let user_id = this.user.user_id;
            
            service.getBusinesses(this, user_id).then(data => {
                if(data.body.status == 200) {
                    this.cnpros = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        addCnpro() {
            var credentials = {
                cnpro_user: this.user.user_id,
                cnpro_category: this.cnpro.category,
                cnpro_name: this.cnpro.name,
                cnpro_email: this.cnpro.email,
                cnpro_phone: this.cnpro.phone,
                cnpro_address: this.cnpro.address,
                cnpro_state: this.cnpro.state,
                cnpro_city: this.cnpro.city,
                cnpro_description: this.cnpro.description
            }

            let navi = this.$router;
            if(credentials.cnpro_user != null || credentials.cnpro_name != null || credentials.cnpro_category != null) {
                service.addCnpro(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Cnpro Added!", "Success!");
                        location.reload(true);
                    }else {
                        toastr.error('Sorry, could not add Cnpro', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        //--//cnpros
        copyLink() {
            // this.$clipboard("fgfgddddjkjkjkj")
        }

    },
    created: function(){
       this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/script.js